import React, {Component} from 'react';
import Attachment from 'catalog/components/Attachment';
import autobind from 'autobind-decorator';
import NewAttachment from 'catalog/components/NewAttachment';

class AttachmentList extends Component {

    render() {
        const attachmentList = this.props.measure.anhang
        return (
            <ul className="list-unstyled" style={{'marginLeft': '1em'}}>
                <li>
                    <NewAttachment measure={this.props.measure} callback={this.addAttachment}/>
                </li>
                {
                    attachmentList.map(
                        (attachment) => <Attachment attachment={attachment} key={`attachment_${attachment.id}`}
                                                    callback={this.addAttachment}/>
                    )
                }
            </ul>
        )
    }

    @autobind
    addAttachment(attachment) {
        this.setState(
            {
                attachments: [...this.state.attachments, attachment]
            }
        )
    }
}

export default AttachmentList;